import { motion } from 'framer-motion';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { CarouselNavigationType } from '../CarouselTypes';
import { CarouselDotNavigation } from './CarouselDotNavigation';

function CarouselNavigation(props: CarouselNavigationType) {
	if (props.dotNavigation) return <CarouselDotNavigation {...props} />;

	return (
		<div className='carousel-navigation-container'>
			<motion.div
				whileHover={{ scale: 1.1 }}
				whileTap={{ scale: 0.95 }}
				className='carousel-navigation-entry'
				onClick={() => props.paginateCallback(-1)}
			>
				<FontAwesomeIcon icon={faChevronLeft} />
			</motion.div>
			<motion.div
				whileHover={{ scale: 1.1 }}
				whileTap={{ scale: 0.95 }}
				className='carousel-navigation-entry'
				onClick={() => props.paginateCallback(1)}
			>
				<FontAwesomeIcon icon={faChevronRight} />
			</motion.div>
		</div>
	);
}

export { CarouselNavigation };
